import React, { useRef, useEffect } from "react";
import { Modal } from "semantic-ui-react";
import SignatureCanvas from "react-signature-canvas";
import { useSelector } from "react-redux";
import { CloseIcon } from "../../../Assets/Icons/svg";
import { selectTranslations } from "../../config/i18n/slice";
import { Spinner } from "reactstrap";

const SignaturePadModal = ({
  isOpen = false,
  setIsOpen = () => {},
  mode = "add",
  initialImage = "",
  onSave = () => {},
  onCancel = () => {},
  loading = false,
}) => {
  const sigCanvas = useRef();
  const t = useSelector(selectTranslations);

  useEffect(() => {
    if (initialImage && sigCanvas.current) {
      const img = new Image();
      img.src = initialImage;
      img.onload = () => {
        const canvas = sigCanvas.current.getCanvas();
        const ctx = canvas.getContext("2d");
        sigCanvas.current.clear();
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      };
    }
  }, [initialImage]);

  const handleSave = (setIsOpen) => {
    if (!sigCanvas.current.isEmpty()) {
      const dataUrl = sigCanvas.current.toDataURL("image/png");
      onSave(dataUrl, setIsOpen);
    }
  };

  return (
    <Modal
      size="tiny"
      className="assets-modal procedure-modal"
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
        onCancel();
      }}
    >
      <div className="header-container">
        <span className="assets-header">
          {mode === "edit" ? t.people.signature.edit : t.people.signature.add}
        </span>
        <div>
          <span
            className="c-pointer text-right"
            onClick={() => {
              setIsOpen(false);
              onCancel();
            }}
          >
            <CloseIcon />
          </span>
        </div>
      </div>

      <Modal.Content>
        <label className="label-item">{t.people.signature.draw}</label>

        <div className="signature-wrapper">
          <span className="clear-btn" onClick={() => sigCanvas.current.clear()}>
            {t.people.signature.clear}
          </span>

          <div className="position-relative">
            <SignatureCanvas
              ref={sigCanvas}
              penColor="black"
              canvasProps={{
                height: 150,
                className: "sigCanvas",
              }}
            />

            <div className="underline" />
          </div>
        </div>
      </Modal.Content>

      <div className="modal-button-container mt-4 mr-8">
        <button
          onClick={() => {
            setIsOpen(false);
            onCancel();
          }}
          className="modal-form-action-button black"
          disabled={loading}
        >
          {t.common.cancel}
        </button>

        <button
          onClick={() => {
            handleSave(setIsOpen);
          }}
          className="modal-form-action-button light-blue signature-btn"
          disabled={loading}
        >
          {loading ? (
            <Spinner color="light" size="sm">
              <div>{null}</div>
            </Spinner>
          ) : (
            t.common.save
          )}{" "}
        </button>
      </div>
    </Modal>
  );
};

export default SignaturePadModal;
